import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "hiddenField", "nameField", "selectedName", "clearButton"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  clickOutside(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  select(event) {
    const { id, name } = event.params
    this.hiddenFieldTarget.value = id
    this.nameFieldTarget.value = name
    this.selectedNameTarget.textContent = name
    this.selectedNameTarget.classList.remove("hidden")
    this.clearButtonTarget.classList.remove("hidden")
    this.close()
  }

  clear() {
    this.hiddenFieldTarget.value = ""
    this.selectedNameTarget.textContent = ""
    this.selectedNameTarget.classList.add("hidden")
    this.clearButtonTarget.classList.add("hidden")
  }
}
